import { UserModel } from '../models';
import { PermissionNames } from './PermissionNames';

// const baseRoute = process.env.REACT_APP_BASE_ROUTE;
const baseRoute = '';

export const ROUTES = {
  SELECT_PROJECT: {
    path: baseRoute + '/select-project',
    permissionList: [PermissionNames.Projects.View],
  },
  BASIC_INFORMATION: {
    path: baseRoute + '/basic-information',
    permissionList: [],
  },
  TAKE_PHOTO: {
    path: baseRoute + '/take-photo',
    permissionList: [],
  },
  REGISTRATION: {
    path: baseRoute + '/registration',
    permissionList: [],
  },
  CREATE_PASSWORD: { path: baseRoute + '/create-password', permissionList: [] },
  TERMS_AND_CONDITIONS: { path: baseRoute + '/terms-and-conditions', permissionList: [] },
  STANDARD_CONSENT_FORM: { path: baseRoute + '/standard-consent-form', permissionList: [] },
  STANDARD_BIOMETRIC_CONSENT: { path: baseRoute + '/standard-biometric-consent', permissionList: [] },
  REGISTRATION_SIGNATURE: { path: baseRoute + '/registration-signature', permissionList: [] },
  PERSONAL_INFORMATION: { path: baseRoute + '/personal-information', permissionList: [] },
  TRADES: { path: baseRoute + '/trades', permissionList: [] },
  CERTIFICATIONS: {
    path: baseRoute + '/certifications',
    permissionList: [PermissionNames.WorkerCertifications.Manage],
  },
  CONSENT_FORM: {
    path: baseRoute + '/consent-form',
    permissionList: [PermissionNames.Workers.Manage],
  },
  CONTACT_INFORMATION: {
    path: baseRoute + '/contact-information',
    permissionList: [],
  },
  PROJECT_LIST: {
    path: baseRoute + '/project-list',
    permissionList: [PermissionNames.Projects.View],
  },
  MY_CERTIFICATIONS: {
    path: baseRoute + '/my-certifications',
    permissionList: [PermissionNames.WorkerCertifications.Manage],
  },
  MY_DRUG_TESTING: {
    path: baseRoute + '/my-drug-testing',
    permissionList: [],
  },
  CONSENT_FORM_INFORMATION: {
    path: baseRoute + '/consent-form-information',
  },
  MY_COURSES: {
    path: baseRoute + '/my-courses',
    permissionList: [],
  },
  IMAGE_PICKER_DEMO: {
    path: baseRoute + '/image-picker-demo',
    permissionList: [],
  },
  MY_PROFILE: {
    path: baseRoute + '/my-profile',
    permissionList: [],
  },
  LOGIN: { path: baseRoute + '/login', permissionList: [] },
  FORGOT_PASSWORD: { path: baseRoute + '/forgot-password', permissionList: [] },
  VERIFY_OTP: { path: baseRoute + '/verify-otp', permissionList: [] },
  CONFIRM_RESET_PASSWORD: { path: baseRoute + '/users/reset-password', permissionList: [] },
  WORKER_STATUS: { path: baseRoute + '/worker-status', permissionList: [] },
};
